import classes from "./SquareLabel.module.css";

const SquareLabel = (props) => {
  const { text, color } = props;

  return (
    <div className={`${classes.label}`} style={{ color: color }}>
      {text}
    </div>
  );
};

export default SquareLabel;
